import { Component, OnInit } from '@angular/core';
import {Role} from "../shared/model/role.model";
import {DataService} from "../shared";
import {UserRolePagesMapping} from "../shared/model/user-role-pages-mapping.model";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  roles: Role[];

  pageInfo: UserRolePagesMapping;

  sharedData: any;
  read: boolean;
  write: boolean;

  constructor(
    private dataService: DataService,
  ) { }

  ngOnInit() {
    this.sharedData = this.dataService.getSharedDataObject();
    this.roles = this.sharedData.get('roles');
    this.pageInfo = this.sharedData.get('CNHIS');
  }

  userAccess( ){
    this.read = true;
    this.write = false;

    /* Only Provider(5) and Service Coordinator(4) are allowed to write in contact history*/

    for( const role of this.roles){
      if( role.id === 5 || role.id === 4 ){
        this.write = true;
      }
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts